<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue';
import { BUTTON_TYPE } from '@/const';

const props = defineProps({ type: String });
const emit = defineEmits(['click']);

const loading = ref(false);

const countDownRef = ref();
const countDownSwitch = ref(false);
const hasGetCode = ref(false);

watch(props, ({ type }) => {
  loading.value = type === BUTTON_TYPE.loading;
  if (type === BUTTON_TYPE.start) {
    countDownSwitch.value = true;
    hasGetCode.value = true;
    countDownRef.value.reset();
  }
  if (type === BUTTON_TYPE.default) {
    hasGetCode.value = false;
  }
});

const handleClick = () => {
  if (!countDownSwitch.value) {
    emit('click');
  }
};
</script>

<template>
  <el-button class="h-12 px-2 custom-button" type="text" :loading="loading" @click="handleClick">
    <div class="inline-flex leading-5" :class="{ 'not-allowed': countDownSwitch }">
      <div v-if="hasGetCode">{{ $t('button.reSend') }}</div>
      <div v-else>{{ $t('button.getCode') }}</div>
      <van-count-down
        :time="60 * 1000"
        ref="countDownRef"
        class="text-inherit"
        v-show="countDownSwitch"
        @finish="countDownSwitch = false"
      >
        <template v-slot="{ seconds }">（{{ seconds }}s）</template>
      </van-count-down>
    </div>
  </el-button>
</template>

<style scoped lang="less">
.not-allowed {
  cursor: not-allowed;
  color: #aeaeae !important;

  &:active {
    color: #aeaeae !important;
  }
}

.custom-button {
  background-color: #ffffff;
  margin-top: -1px;
}
</style>
